import { useImperativeHandle, forwardRef } from "react";
import { useTour } from "@reactour/tour";

const TourBridge = forwardRef((props, ref) => {
    const { setIsOpen, setSteps } = useTour();

    const startTour = () => {
        setIsOpen(true);
    };

    // Expose the function via ref
    useImperativeHandle(ref, () => ({
        startTour,
        setSteps,
    }));

    return <></>;
});

export default TourBridge;
